@let _iconPos = iconPos();
@let _isOpened = isOpened();
@let _closeOthers = closeOthers();
@let _brand = brand();
@let _iconNameOpened = iconNameOpened();
@let _iconSize = iconSize();
@let _buttonOpenHiddenTitle = buttonOpenHiddenTitle();
@let _iconNameClosed = iconNameClosed();
@let _titleLevel = titleLevel();
@let _theme = theme();
@let _titleCustomClass = titleCustomClass();
@let _detail = detail();
@let _titleIcon = titleIcon();
@let _titleInfo = titleInfo();

<header
  class="c__title {{ _iconPos === PositionEnum.right ? 'is-icon-right' : '' }}"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.Space)="onClick()"
  [attr.aria-expanded]="_isOpened"
  tabindex="0"
  role="button"
>
  @if ((!_closeOthers && _iconPos === PositionEnum.left) || (_isOpened && _closeOthers)) {
    @if (_isOpened) {
      <sd-icon [brand]="_brand" [name]="_iconNameOpened" [size]="_iconSize" />
      @if (_buttonOpenHiddenTitle) {
        <p class="is-visually-hidden">
          {{ _buttonOpenHiddenTitle }}
        </p>
      }
    }
    @if (!_isOpened) {
      <sd-icon [brand]="_brand" [name]="_iconNameClosed" [size]="_iconSize" />
    }
  }

  <sd-title [titleLevel]="_titleLevel"
    [titleThemesConfig]="_theme"
    [customClass]="_titleCustomClass ? _titleCustomClass : 'brand--h5'"
    [isDescription]="isDescription()"
  >
    @if (_titleIcon) {
      <sd-banner [isFit]="true" [media]="_titleIcon" class="c__title-icon" />
    }
    <sd-html [html]="title()" tag="span" innerClass="is-bold"/>
    @if (_titleInfo){
      <sd-html [html]="'&nbsp;' + _titleInfo" tag="span" innerClass="is-medium c__title-info {{ isMobile() ? 'is-body-s' : 'is-caption' }}" />
    }
  </sd-title>

  @if (_detail) {
    <sd-title
      class="c__detail"
      [titleLevel]="_titleLevel"
      [titleThemesConfig]="_theme"
      [customClass]="_titleCustomClass ? _titleCustomClass : 'brand--h5'"
    >
      <sd-html [html]="_detail" tag="span" />
    </sd-title>
  }

  @if ((!_closeOthers && _iconPos === PositionEnum.right) || (!_isOpened && _closeOthers)) {
    @if (_isOpened) {
      <sd-icon [brand]="_brand" [name]="_iconNameOpened" [size]="_iconSize" />
      @if (_buttonOpenHiddenTitle) {
        <p class="is-visually-hidden">
          {{ _buttonOpenHiddenTitle }}
        </p>
      }
    }
    @if (!_isOpened) {
      <sd-icon [brand]="_brand" [name]="_iconNameClosed" [size]="_iconSize" />
    }
  }
</header>

<div
  class="c__body {{ isNested() ? 'is-sub-accordion' : '' }} {{ hasNoPadding() ? 'has-no-padding' : '' }}"
  role="region"
  [@expandCollapse]="_isOpened ? '1' : '0'"
  [attr.aria-expanded]="_isOpened"
  [attr.aria-hidden]="!_isOpened"
>
  <div class="c__padding-wrapper">
    <ng-content />
  </div>
</div>
